import $ from 'jquery'
import Alpine from 'alpinejs'
import ImagesLoaded from './socialscan/modules/ImagesLoaded'
import RelativeUrls from './socialscan/modules/RelativeUrls'
import ViewHeigthFix from './socialscan/modules/patches/ViewHeigthFix'
import HideFieldsOnFormSuccess from './socialscan/modules/forms/HideFieldsOnFormSuccess'
import Validation from './socialscan/modules/forms/Validation'
import Swiper from './socialscan/modules/Swiper'

(() => {
    window.$ = window.jQuery = $ // Load jQuery globally for OctoberCMS frontend framework

    window.Alpine = Alpine

    // Patches
    ViewHeigthFix()

    // Forms
    HideFieldsOnFormSuccess()
    Alpine.data('validation', Validation);

    // Other
    ImagesLoaded()
    RelativeUrls()

    Swiper()

    Alpine.start()

})()
